import { render, staticRenderFns } from "./TransferTokens.vue?vue&type=template&id=3b9c4832&scoped=true"
import script from "./TransferTokens.vue?vue&type=script&lang=ts"
export * from "./TransferTokens.vue?vue&type=script&lang=ts"
import style0 from "./TransferTokens.vue?vue&type=style&index=0&id=3b9c4832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c4832",
  null
  
)

export default component.exports